// extracted by mini-css-extract-plugin
export var container = "TimelineComponent-module--container--mCqFj";
export var contents = "TimelineComponent-module--contents--1ilTO";
export var description = "TimelineComponent-module--description--lx+vT";
export var imageContainer = "TimelineComponent-module--image-container--AxoXQ";
export var link = "TimelineComponent-module--link--p5uhQ";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var tagline = "TimelineComponent-module--tagline--obl6o";
export var title = "TimelineComponent-module--title--gE3cV";